import React, { useRef } from "react";
import dateUtil from "../../utls/DateUtil";
import "./index.less";
import { useTranslation } from "react-i18next";

type props = {
  className?: string;
  date?: string | null;
  name?: string;
  onChange?: (value: string | null) => void;
  disabled?: boolean;
  suffix?: React.ReactNode;
};

const DatePickerComponent: React.FC<props> = ({ className, name, date, onChange, disabled = false, suffix }) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const parsedDate = date ? new Date(date) : null;
  const formattedDate = parsedDate && !isNaN(parsedDate.getTime()) ? dateUtil.convertDateTimeStringToDateString(date!) : "";
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  const maxDateString = dateUtil.convertDateTimeStringToDateString(maxDate.toISOString());

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value || null);
    }
  };

  const handleWrapperClick = () => {
    if (inputRef.current && !disabled) {
      inputRef.current.showPicker?.();
    }
  };

  return (
    <div className={`date-picker-wrapper ${disabled ? "disabled" : ""}`} onClick={handleWrapperClick}>
      {!formattedDate && <span className="date-picker-placeholder">{t("date-of-birth-label")}</span>}
      <input
        ref={inputRef}
        type="date"
        name={name || ""}
        className={`datePicker ${className || ""}`}
        value={formattedDate}
        onChange={handleChange}
        max={maxDateString}
        disabled={disabled}
      />
      {suffix && <span className="date-picker-suffix">{suffix}</span>}
    </div>
  );
};

export default DatePickerComponent;
